import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@redotech/redo-web/components/ui/popover";
import { memo, useState } from "react";
import * as askRedoStyles from "./ask-redo-button.module.css";
import { FeedbackCallout } from "./feedback-callout";
import * as css from "./feedback-callout.module.css";

export const FeedbackButton = memo(function FeedbackButton() {
  const [open, setOpen] = useState(false);

  return (
    <Popover onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild>
        <RedoButton
          buttonClassName={askRedoStyles.button}
          className="dark-mode"
          dataTrackId="merchant.top-nav.feedback.open"
          hierarchy="secondary"
          size="sm"
          text="Feedback"
        />
      </PopoverTrigger>
      <PopoverContent align="end" className={css.popoverContent} sideOffset={8}>
        <FeedbackCallout onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
});
